import RegisterCom from 'components/Register'
import React, {useCallback} from 'react'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import BasicLayout from './components/BasicLayout'
import Login from './components/Login'
import NotFound from './components/NotFound'
import RetrievePassword from './components/RetrievePassword'

interface IProps {}
const MRouter = (props: IProps) => {
  const onEnter = useCallback((Component, props) => {
    return <Component {...props} />
  }, [])

  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/login" component={Login}></Route>
          <Route path="/retrieve" component={RetrievePassword}></Route>
          <Route path="/register" component={RegisterCom}></Route>
          <Route path="/" render={props => onEnter(BasicLayout, props)}></Route>
          
          <Route component={NotFound}></Route>
        </Switch>
      </Router>
    </>
  )
}

export default MRouter
